// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Selector y insignias del modo del cliente. Ver clientModes.tsx. */

.clientModes_selector__-njYr {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.clientModes_options__rInvM {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 8px;
}

/* Cada opción es una etiqueta completa y no solo la casilla: el área de clic
   abarca el icono y el texto, que es lo que se intenta pulsar. */
.clientModes_option__Q4oMD {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 11px;
  border: 1px solid var(--dylo-field-border);
  border-radius: 10px;
  background: var(--dylo-field-bg);
  color: var(--dylo-muted);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;
}

.clientModes_option__Q4oMD:hover {
  border-color: var(--dylo-orange);
}

.clientModes_optionOn__EDVu- {
  border-color: var(--dylo-orange);
  /* Tinte del propio acento en vez de un color fijo, para que funcione en los dos temas. */
  background: color-mix(in srgb, var(--dylo-orange) 10%, transparent);
  color: var(--dylo-text);
}

/* La casilla nativa se conserva (accesibilidad y foco del sistema) y solo se le
   ajusta el acento. Reemplazarla por un cuadro dibujado obliga a reimplementar
   el foco por teclado, que es justo lo que se rompe al hacerlo. */
.clientModes_checkbox__AZy5X {
  width: 15px;
  height: 15px;
  margin: 0;
  accent-color: var(--dylo-orange);
  cursor: pointer;
}

.clientModes_option__Q4oMD:has(.clientModes_checkbox__AZy5X:focus-visible) {
  outline: 2px solid var(--dylo-orange);
  outline-offset: 2px;
}

.clientModes_optionIcon__xBWWM {
  display: flex;
  align-items: center;
  color: currentColor;
}

.clientModes_optionLabel__jveRc {
  font-size: 0.86rem;
  font-weight: 600;
  white-space: nowrap;
}

.clientModes_warning__LRKcA {
  font-size: 0.78rem;
  color: var(--dylo-orange);
  line-height: 1.35;
}

/* ------------------------------- Insignias ------------------------------- */

.clientModes_badges__rsS-Y {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;
}

.clientModes_badge__rbNwW {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  border: 1px solid currentColor;
  background: color-mix(in srgb, currentColor 12%, transparent);
}

.clientModes_badgeIcon__L7O7D {
  display: flex;
  align-items: center;
}

/* Mismos colores por modo que usan la tabla de embarques y sus tarjetas. */
.clientModes_badge_land__4S6oU {
  color: var(--dylo-orange);
}
.clientModes_badge_ocean__AuABi {
  color: var(--dylo-blue-500);
}
.clientModes_badge_air__pLxzo {
  color: var(--dylo-teal-500);
}

.clientModes_badgeAll__4H3Cr,
.clientModes_badgeNone__ntSuv {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 700;
  border: 1px solid currentColor;
  background: color-mix(in srgb, currentColor 12%, transparent);
}

.clientModes_badgeAll__4H3Cr {
  color: var(--dylo-muted);
}

/* Sin modo el cliente no se ofrece en ninguna parte: se marca en color de alerta
   porque es un estado que casi siempre es un descuido. */
.clientModes_badgeNone__ntSuv {
  color: #e8590c;
}

/* ---------------------------- Insignia compacta ---------------------------- */

/* Solo iconos, para el renglón del nombre en la lista de clientes.
   Ver la nota en \`clientModes.tsx\`: con texto no cabía en la pastilla del pie y se
   iba al segundo renglón, creciendo el pie de todas las tarjetas. */
.clientModes_badgeCompact__r1it5 {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  /* No se encoge ni se parte: es lo que provocaba el descuadre. */
  flex-shrink: 0;
  flex-wrap: nowrap;
}

.clientModes_compactIcon__a8t3X {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 1px solid currentColor;
  background: color-mix(in srgb, currentColor 12%, transparent);
}

/* Sin modo: el cliente no se ofrece en ninguna parte, así que se marca en alerta.
   Se usa un signo y no un icono de modo, porque no hay ninguno que mostrar. */
.clientModes_compactNone__UVJwx {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 1px solid #e8590c;
  background: color-mix(in srgb, #e8590c 12%, transparent);
  color: #e8590c;
  font-size: 0.8rem;
  font-weight: 800;
}
`, "",{"version":3,"sources":["webpack://./src/v2/pages/Clients/clientModes.module.css"],"names":[],"mappings":"AAAA,oEAAoE;;AAEpE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;AACV;;AAEA;iEACiE;AACjE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,0CAA0C;EAC1C,mBAAmB;EACnB,gCAAgC;EAChC,wBAAwB;EACxB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,4EAA4E;AAC9E;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,yFAAyF;EACzF,mEAAmE;EACnE,uBAAuB;AACzB;;AAEA;;kEAEkE;AAClE;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,8EAA8E;;AAE9E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;EAC9B,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,2EAA2E;AAC3E;EACE,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,6DAA6D;AAC/D;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;yDACyD;AACzD;EACE,cAAc;AAChB;;AAEA,gFAAgF;;AAEhF;;oEAEoE;AACpE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gEAAgE;EAChE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,6DAA6D;AAC/D;;AAEA;8EAC8E;AAC9E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,wDAAwD;EACxD,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":["/* Selector y insignias del modo del cliente. Ver clientModes.tsx. */\n\n.selector {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.options {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  gap: 8px;\n}\n\n/* Cada opción es una etiqueta completa y no solo la casilla: el área de clic\n   abarca el icono y el texto, que es lo que se intenta pulsar. */\n.option {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 9px 11px;\n  border: 1px solid var(--dylo-field-border);\n  border-radius: 10px;\n  background: var(--dylo-field-bg);\n  color: var(--dylo-muted);\n  cursor: pointer;\n  user-select: none;\n  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;\n}\n\n.option:hover {\n  border-color: var(--dylo-orange);\n}\n\n.optionOn {\n  border-color: var(--dylo-orange);\n  /* Tinte del propio acento en vez de un color fijo, para que funcione en los dos temas. */\n  background: color-mix(in srgb, var(--dylo-orange) 10%, transparent);\n  color: var(--dylo-text);\n}\n\n/* La casilla nativa se conserva (accesibilidad y foco del sistema) y solo se le\n   ajusta el acento. Reemplazarla por un cuadro dibujado obliga a reimplementar\n   el foco por teclado, que es justo lo que se rompe al hacerlo. */\n.checkbox {\n  width: 15px;\n  height: 15px;\n  margin: 0;\n  accent-color: var(--dylo-orange);\n  cursor: pointer;\n}\n\n.option:has(.checkbox:focus-visible) {\n  outline: 2px solid var(--dylo-orange);\n  outline-offset: 2px;\n}\n\n.optionIcon {\n  display: flex;\n  align-items: center;\n  color: currentColor;\n}\n\n.optionLabel {\n  font-size: 0.86rem;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.warning {\n  font-size: 0.78rem;\n  color: var(--dylo-orange);\n  line-height: 1.35;\n}\n\n/* ------------------------------- Insignias ------------------------------- */\n\n.badges {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  flex-wrap: wrap;\n}\n\n.badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  border: 1px solid currentColor;\n  background: color-mix(in srgb, currentColor 12%, transparent);\n}\n\n.badgeIcon {\n  display: flex;\n  align-items: center;\n}\n\n/* Mismos colores por modo que usan la tabla de embarques y sus tarjetas. */\n.badge_land {\n  color: var(--dylo-orange);\n}\n.badge_ocean {\n  color: var(--dylo-blue-500);\n}\n.badge_air {\n  color: var(--dylo-teal-500);\n}\n\n.badgeAll,\n.badgeNone {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  border: 1px solid currentColor;\n  background: color-mix(in srgb, currentColor 12%, transparent);\n}\n\n.badgeAll {\n  color: var(--dylo-muted);\n}\n\n/* Sin modo el cliente no se ofrece en ninguna parte: se marca en color de alerta\n   porque es un estado que casi siempre es un descuido. */\n.badgeNone {\n  color: #e8590c;\n}\n\n/* ---------------------------- Insignia compacta ---------------------------- */\n\n/* Solo iconos, para el renglón del nombre en la lista de clientes.\n   Ver la nota en `clientModes.tsx`: con texto no cabía en la pastilla del pie y se\n   iba al segundo renglón, creciendo el pie de todas las tarjetas. */\n.badgeCompact {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  /* No se encoge ni se parte: es lo que provocaba el descuadre. */\n  flex-shrink: 0;\n  flex-wrap: nowrap;\n}\n\n.compactIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  border: 1px solid currentColor;\n  background: color-mix(in srgb, currentColor 12%, transparent);\n}\n\n/* Sin modo: el cliente no se ofrece en ninguna parte, así que se marca en alerta.\n   Se usa un signo y no un icono de modo, porque no hay ninguno que mostrar. */\n.compactNone {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  border: 1px solid #e8590c;\n  background: color-mix(in srgb, #e8590c 12%, transparent);\n  color: #e8590c;\n  font-size: 0.8rem;\n  font-weight: 800;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selector": `clientModes_selector__-njYr`,
	"options": `clientModes_options__rInvM`,
	"option": `clientModes_option__Q4oMD`,
	"optionOn": `clientModes_optionOn__EDVu-`,
	"checkbox": `clientModes_checkbox__AZy5X`,
	"optionIcon": `clientModes_optionIcon__xBWWM`,
	"optionLabel": `clientModes_optionLabel__jveRc`,
	"warning": `clientModes_warning__LRKcA`,
	"badges": `clientModes_badges__rsS-Y`,
	"badge": `clientModes_badge__rbNwW`,
	"badgeIcon": `clientModes_badgeIcon__L7O7D`,
	"badge_land": `clientModes_badge_land__4S6oU`,
	"badge_ocean": `clientModes_badge_ocean__AuABi`,
	"badge_air": `clientModes_badge_air__pLxzo`,
	"badgeAll": `clientModes_badgeAll__4H3Cr`,
	"badgeNone": `clientModes_badgeNone__ntSuv`,
	"badgeCompact": `clientModes_badgeCompact__r1it5`,
	"compactIcon": `clientModes_compactIcon__a8t3X`,
	"compactNone": `clientModes_compactNone__UVJwx`
};
export default ___CSS_LOADER_EXPORT___;
